<template lang="html">
  <!-- Trial -->
  <b-row class="mb-5">
    <b-col>
      <!-- Trial ongoing -->
      <div class="alert alert-info col-10 offset-1 mt-3">
        <b-row v-if="validTrialPeriod">
          <b-col md="6">
            You have
            <strong>
              {{ trialDaysRemaining }}
              {{ "day" | pluralize(trialDaysRemaining) }}
            </strong>
            remaining on your trial account.
          </b-col>
          <b-col md="6" class="text-right">
            <b-link :to="{ name: 'upgrade_view', params: {} }">
              {{ randomTrialMessage }}
            </b-link>
          </b-col>
          <!--
          <b-col md="12" class="mt-3 mb-0">
            <p>
              Trial accounts are provided for your evaluation. Exported videos
              are watermarked and limited to smaller resolutions.
            </p>
          </b-col>
        -->
        </b-row>

        <!-- Trial period has ended -->
        <b-row v-else>
          <b-col>
            Your Soundslides 3 trial period has ended.
          </b-col>
          <b-col class="text-right">
            <b-link :to="{ name: 'upgrade_view', params: {} }">
              Upgrade for less than $4 a month
            </b-link>
          </b-col>
        </b-row>

        <!-- Approaching show limits -->

        <b-row v-if="limitApproaching && !limitMet">
          <b-col>
            <p class="mt-3">
              Only {{ numberUntilLimit }} new
              {{ "show" | pluralize(numberUntilLimit) }} remaining for your
              trial account.
            </p>
          </b-col>
        </b-row>

        <!-- Over limits -->
        <b-row v-if="limitApproaching && limitMet">
          <b-col>
            <h5 class="mt-4">
              You're reached the show limit ({{ slideshowTotal }} of
              {{ $store.state.user_plan.show_limit }}) for your trial account.
            </h5>
            <p class="mt-3">
              Please remove a show, or consider upgrading to a paid account.
            </p>
          </b-col>
        </b-row>
      </div>
    </b-col>
  </b-row>
</template>

<script>
import { differenceInDays } from "date-fns";
import reject from "lodash/reject";
import sortBy from "lodash/sortBy";
import sample from "lodash/sample";
export default {
  name: "TrialMessage",
  filters: {
    pluralize(word, amount) {
      if (amount > 1) {
        return `${word}s`;
      }
      return word;
    },
  },
  data() {
    return {
      trialMessages: [
        "HD-enabled plans start at just $5!",
        "Upgrade for less than $4 a month",
      ],
    };
  },
  computed: {
    randomTrialMessage() {
      return sample(this.trialMessages);
    },
    validTrialPeriod() {
      if ("expired" in this.$route.query) {
        return false;
      }
      return this.$store.state.validTrialPeriod;
    },
    trialDaysRemaining() {
      return this.$store.state.trialDaysRemaining;
    },
    ageOfAccount() {
      var createdDate = new Date(this.$store.state.user_doc.created_at);
      return differenceInDays(new Date(), createdDate);
    },
    slideshowTotal() {
      return this.$store.getters.slideshowTotal;
    },
    oldestNonDemoEditAge() {
      // Include deleted shows here.
      var show_index = this.$store.state.editor_shows;
      var nonDemoShows = reject(show_index, { forked: true });
      var sorted = sortBy(nonDemoShows, "created_at");
      if (sorted.length > 0) {
        var createdDate = new Date(sorted[0].created_at);
        return differenceInDays(new Date(), createdDate);
      } else {
        // User has not create their own edit at all. Consider extending trial.
        return null;
      }
    },
    limitMet() {
      return this.$store.getters.trialShowLimitReached;
    },
    limitApproaching() {
      return this.$store.getters.limitApproaching;
    },
    numberUntilLimit() {
      return this.$store.state.user_plan.show_limit - this.slideshowTotal;
    },
  },
};
</script>

<style lang="css" scoped></style>
